import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class LocalSysChartAcctMapDeleteService {

  constructor(private http: HttpClient) { }

  // 🚀 CRITICAL: Check transactions before delete - following AngularJS pattern
  checkTransactions(
    baseUrl: string,
    params: any
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    
    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }

  // 🚀 CRITICAL: Following AngularJS DeleteChartAcctMap pattern exactly
  deleteChartAcctMap(
    baseUrl: string,
    confirmObj: any,
    deleteDetails: any[],
    globalService: any,
    filterParams: any,
    rowData: any 
  ): Observable<any> {
    
    // 🚀 CRITICAL: URL construction with action code like AngularJS service
    const url = `${baseUrl}/saveJsonObject?action_code=6us3oe`;

    // 🚀 CRITICAL: Build JSON objects exactly like AngularJS service
    // jsonSettings: single object with system_acct_key, local_acct_key, local_chart_key, tax_year, scenario, jcd_key
    const jsonSettings = JSON.stringify(confirmObj || {});
    
    // jsonObj: array with same structure
    const jsonObj = JSON.stringify(deleteDetails || []);

    // 🚀 CRITICAL: Build AngularJS-compatible payload structure
    // globalService might be globalParams object directly or have globalParams property
    const globalParams = globalService|| globalService || {};
    let params: any = _.merge({}, globalParams, filterParams);
    
    // Add jsonObj and jsonSettings
    params.jsonObj = jsonObj;
    params.jsonSettings = jsonSettings;
    
    // Core parameters from filterParams, globalParams, or rowData with fallbacks

    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.globalParams?.scenarioCode || globalService?.globalParams?.scenario_code || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.globalParams?.is_issue_key_enabled || 'N';
    params.tax_year = filterParams?.tax_year || globalParams?.tax_year || rowData?.TAX_YEAR || confirmObj?.tax_year || '';
    params.screen_key = filterParams?.screen_key || globalParams?.screen_key || rowData?.SCREEN_KEY || '155';
    params.scenario = filterParams?.scenario || globalParams?.scenario || rowData?.SCENARIO || confirmObj?.scenario || '';
    params.jcd_key = filterParams?.jcd_key || globalParams?.jcd_key || rowData?.JCD_KEY || confirmObj?.jcd_key || '';
    params.jcd_ta_key = filterParams?.jcd_ta_key || globalParams?.jcd_ta_key || rowData?.JCD_TA_KEY || '1113';
    params.activity_key = filterParams?.activity_key || globalParams?.activity_key || rowData?.ACTIVITY_KEY || '384';
    params.screen_type = filterParams?.screen_type || globalParams?.screen_type || 'grid';
    params.is_locked = filterParams?.is_locked || globalParams?.is_locked || 'N';
    
    // Issue-related fields (empty strings if not provided)
    params.issue_id = filterParams?.issue_id || globalParams?.issue_id || '';
    params.issue_short_desc = filterParams?.issue_short_desc || globalParams?.issue_short_desc || '';
    params.issue_id_for_tx_save = filterParams?.issue_id_for_tx_save || globalParams?.issue_id_for_tx_save || '';
    
    // Standard fields
    params.scenarioCode = filterParams?.scenarioCode || globalParams?.scenarioCode || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalParams?.is_issue_key_enabled || 'N';
    params.entity_type = filterParams?.entity_type || globalParams?.entity_type || 'REG';
    
    // chart_filter: from local_chart_key in confirmObj or deleteDetails (should be numeric)
    const chartFilterValue = confirmObj?.local_chart_key || (deleteDetails && deleteDetails.length > 0 ? deleteDetails[0]?.local_chart_key : 0);
    params.chart_filter = chartFilterValue ? String(chartFilterValue) : '';
    
    // checkLockedbj: array with scenario_key
    const scenarioKey = parseInt(params.scenario || '74');
    const checkLockedbj = [{ "scenario_key": scenarioKey }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);
    
    // Set process_name exactly like AngularJS
    params.process_name = "Delete_Chart_Acct_Map";

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}


